<template>
  <div class="device-overview-card">
    <!-- 表格主体 -->
    <div class="list">
      <div class="iterm" v-for="(item, index) in data" :key="index">
        <el-card class="product-card" shadow="never" bordered>
          <!-- 产品图片区域 -->
          <div class="product-img">
            <el-image
              v-if="item.image_oss_id"
              style="width: 100%; height: 200px; object-fit: cover;"
              :src="`${imgUrl}${item.image_oss_id}`"
              :preview-src-list="[`${imgUrl}${item.image_oss_id}`]"
            ></el-image>
            <!-- 无图片时的占位图 -->
            <div v-else class="no-img-placeholder">无图片</div>
            <el-tag v-if="item.video_url" type="purple" size="small" class="video-tag" @click="playVideo(item)">
              <i class="el-icon-video-play"></i> 安装视频
            </el-tag>
          </div>
          <!-- 产品信息区域 -->
          <div class="product-info">
            <h3 class="product-name">{{ item.name }}</h3>
            <p class="product-model">型号: {{ item.model }}</p>
            <div class="tag-group">
              <el-tag
                v-for="type_id in item.type_id"
                :key="type_id"
                size="small"
                effect="plain"
                type="info"
              >
                {{ item.type_name }}
              </el-tag>
            </div>
            <p class="product-desc">{{ item.description }}</p>
            <div class="product_foot">
              <!-- <div class="price-stock">
                <span class="product-price">¥{{ item.price }}</span>
                <span class="product-stock">库存: {{ item.stock }}</span>
              </div> -->
              <div class="product-actions">
                <el-button type="text" icon="el-icon-edit" @click="editSpareParts(item)"></el-button>
                <el-button type="text" icon="el-icon-delete" class="delete-btn" @click="deleteSpareParts(item)"></el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 分页控件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pageSizes"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
    <el-dialog
      title="视频播放"
      :visible.sync="videoDialogVisible"
      width="1115px"
      center
      :close-on-click-modal="false"
    >
      <div class="video-container">
        <video v-if="currentVideoUrl" height="600" :key="currentVideoUrl" controls>
          <source :src="`${imgUrl}${currentVideoUrl}`"  type="video/mp4">
        </video>
        <el-empty v-else description="暂无视频资源"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
export default {
  name: 'ProductOverviewCard',
  props: {
    data: {
      type: Array,
      default: () => [
        {
          image_oss_id: '你的图片ID', // 替换为实际图片ID
          video_url: '你的视频ID', // 替换为实际视频ID
          name: '焊枪喷嘴组件',
          model: 'WG-N001',
          tags: ['焊接配件', '焊接设备'],
          description: '适用于WR系列焊接机器人，铜制材料，耐高温耐磨损',
          price: 280,
          stock: 150
        }
      ]
    },
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 6,
        total: 1
      })
    },
    pageSizes: {
      type: Array,
      default: () => [6, 10, 20, 30]
    }
  },
  data() {
    return {
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      videoDialogVisible: false, // 视频弹窗显隐控制
      currentVideoUrl: '' // 当前播放视频地址
    }
  },
  methods: {
    playVideo(row) {
      this.videoDialogVisible = true
      this.currentVideoUrl = row.video_url
    },
    handleSizeChange(newSize) {
      this.$emit('size-change', newSize)
    },
    handleCurrentChange(newPage) {
      this.$emit('current-page-change', newPage)
    },
    editSpareParts(item) {
      console.log('编辑')
      this.$emit('edit-spareparts', item)
    },
    deleteSpareParts(item) {
      this.$emit('delete-spareparts', item)
    }
  }
}
</script>

<style scoped>
.device-overview-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 卡片容器布局 */
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  overflow-y: auto;
  height: calc(100% - 63px);
  margin-bottom: 15px;
}

/* 每个卡片样式 */
.iterm {
  flex: 0 0 calc(33.333% - 14px);
  box-sizing: border-box;
  max-height: 420px;
}

/* 卡片内部样式 */
.product-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0 !important;
}

.el-card__body {
  padding: 0;
}

.product-img {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.no-img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  font-size: 14px;
}

.video-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
}

.video-tag .el-icon {
  margin-right: 4px;
}

.product-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.product-model {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.tag-group {
  margin-bottom: 8px;
}

.tag-group .el-tag {
  margin-right: 8px;
  background: #f0f0f0;
  color: #666;
}

.product-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 12px;
  flex: 1;
}

.product_foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.price-stock {
  display: flex;
  flex-direction: column;
}

.product-price {
  font-size: 18px;
  color: #e4393c;
  font-weight: 600;
}

.product-stock {
  font-size: 14px;
  color: #666;
}

/* 操作按钮样式优化 */
.product-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 放大按钮尺寸 */
.product-actions .el-button {
  padding: 5px 10px;
  /* 增加按钮内边距 */
  font-size: 15px;
  /* 放大图标大小 */
}

.delete-btn {
  color: #f56c6c;
}

/* 分页样式 */
.pagination {
  padding-right: 16px;
  text-align: right;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .iterm {
    flex: 0 0 calc(50% - 10px);
  }
}

@media (max-width: 768px) {
  .iterm {
    flex: 0 0 100%;
  }

  .product-img {
    height: 150px;
  }
}

.video-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中（可选，使视频在容器中垂直居中） */
  width: 100%;
  padding: 20px 0; /* 上下留白，提升视觉效果 */
}

/* 确保视频不超出容器宽度（适配小屏幕） */
.video-container video {
  max-width: 100%; /* 防止视频过宽溢出弹窗 */
  object-fit: contain; /* 保持视频比例，不拉伸 */
}

</style>
